import { withStyles } from '@material-ui/core';
import { PrintOutlined as Print, SaveAltSharp, Close as CloseIcon } from '@material-ui/icons';
import SearchBox from '../../../../../common/SearchBox';
import Tooltip from '../../../../../common/StyledToolTip';
import { useReactToPrint } from 'react-to-print';
import './../Print/print.scss';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

const styles = (theme) => ({
  moduleHeader: {
    color: theme.HeaderSelectedText,
    borderBottom: `1px solid ${theme.AppBGColor}`,
    fontWeight: 'bold',
    fontSize: theme.headerTextFontSize,
    padding: '2px 10px 8px 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  gridActionIcons: {
    display: 'flex',
    alignItems: 'center',
    float: 'right',
  },
  headerIconStyles: {
    padding: '5px 10px',
    borderLeft: `1px solid ${theme.AppBGColor}`,
    cursor: 'pointer',
    color: theme.iconColor
  }
});

const Header = ({
  classes,
  exportCSV,
  title,
  gridApi,
  printRef,
  updateQuickFilterText,
  onCloseModel,
  onAfterPrint,
  onBeforeGetContent = null,
  showPrint = false
}) => {
  const handlePrintClick = (e) => {
    e.stopPropagation();
    handlePrint();
  };

  const handlePrint = useReactToPrint({
    content: () => printRef,
    onBeforeGetContent: onBeforeGetContent,
    copyStyles: true,
    onAfterPrint: onAfterPrint,
    pageStyle: 'print'
  });

  return (
    <header className={classes.moduleHeader}>
      <span>{title}</span>
      <div className={classes.gridActionIcons}>
        <SearchBox onChange={updateQuickFilterText} />
        <ClearAllFilterButton gridApi={gridApi} />
        {showPrint && (
          <Tooltip title="Print report data">
            <Print className={classes.headerIconStyles} onClick={handlePrintClick} />
          </Tooltip>
        )}
        <span onClick={exportCSV} className={classes.headerIconStyles}>
          <Tooltip title="Export Data">
            <SaveAltSharp />
          </Tooltip>
        </span>
        <span onClick={onCloseModel} className={classes.headerIconStyles}>
          <Tooltip title="Close">
            <CloseIcon />
          </Tooltip>
        </span>
      </div>
    </header>
  );
};

export default withStyles(styles)(Header);
